/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Editor } from "@tinymce/tinymce-react";
import { API_URL, STORAGE_URL, TINYMCE_API_KEY } from "../../config/env";
import { ProyectosPorProveedorGet } from "../../service/proyectos";
import useLogin from "../../hooks/useLogin";
import {
  ContratosGet,
  ContratosAdd,
  ContratosUpdate,
  ContratosDelete,
} from "../../service/contratos";
import Add from "./Modal/Add";
import Update from "./Modal/Update";
import Swal from "sweetalert2";
import { ConfiguracionGet } from "../../service/configuracion";
import { ProveedorGet } from "../../service/proveedor";
import ReadOnlyNote from "../../components/Form/ReadOnlyNote";

export default function Contratos() {
  const { token, user_rol } = useLogin();
  // Antes cualquiera que entrara a /contratos por URL directa (sin pasar por
  // el menú) podía crear, editar y eliminar plantillas de contrato: la página
  // no tenía ningún control de rol, a diferencia de proyectos/usuarios/etc.
  const canManage =
    user_rol === "super administrador" ||
    user_rol === "cliente" ||
    user_rol === "abogado";
  const editorRef = React.useRef(null);
  const editorActualizarRef = React.useRef(null);
  const [arrayContratosProd, setarrayContratosProd] = React.useState([]);
  const [openAgregar, setopenAgregar] = React.useState(false);
  const [openActualizar, setopenActualizar] = React.useState(false);
  const [form, setform] = React.useState({
    plantilla_nombre: "",
    plantilla_descripcion: "",
    plantilla_estado: "",
    proyecto_id: "",
    proveedor_id: "",
    plantilla_value: "",
    documento: "",
    estatus: "En proceso",
  });
  const [proveedores, setproveedores] = React.useState([]);
  const [proveedoresReales, setproveedoresReales] = React.useState([]);
  // Antes Proveedor y Proyecto eran dos listas sueltas sin relación: se podía
  // armar un contrato con un proveedor y un proyecto que no tenían nada que
  // ver entre sí. Ahora el Proyecto se filtra a los que ese proveedor
  // realmente tiene asignados en el presupuesto.
  const [proyectosDelProveedor, setProyectosDelProveedor] = React.useState([]);

  React.useEffect(() => {
    if (!form.proveedor_id) {
      setProyectosDelProveedor([]);
      return;
    }
    ProyectosPorProveedorGet(form.proveedor_id, token).then((res) => {
      setProyectosDelProveedor(res ?? []);
    });
  }, [form.proveedor_id, token]);

  const toggleAgregar = () => setopenAgregar(!openAgregar);
  const toggleActualizar = () => {
    setopenActualizar(!openActualizar);
  };

  React.useEffect(() => {
    ContratosGet(token).then((res) => {
      setarrayContratosProd(res?.data ?? []);
    });

    ConfiguracionGet(token).then((response) => {
      if (response.success) {
        const { data } = response;
        data.preguntas_json = JSON.parse(data.preguntas);
        setproveedores(data.preguntas_json);
      }
    });

    ProveedorGet(0, token).then((response) => {
      setproveedoresReales(response ?? []);
    });

    return () => {};
  }, []);

  React.useEffect(() => {
    if (openActualizar) {
      setTimeout(() => {
        editorActualizarRef.current.setContent(form.plantilla_value);
      }, 1000);
    }
    return () => {};
  }, [openActualizar]);

  return (
    <div>
      <h5>Plantillas de contratos</h5>
      <div className="d-flex justify-content-end">
        {canManage ? (
          <button className="btn btn-dark btn-sm" onClick={() => toggleAgregar()}>
            Agregar
          </button>
        ) : (
          <ReadOnlyNote />
        )}
      </div>
      <div className="row">
        <div className="col-md-12">
          <table className="table table-sm table-hover">
            <thead>
              <tr>
                <th>Plantilla</th>
                <th>Proyecto</th>
                <th>Proveedor</th>
                <th>Documento</th>
                {/*<th>Estado</th>*/}
                <th>Estatus</th>
                <th colSpan={4}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {arrayContratosProd.map((contrato, index) => (
                <tr key={index}>
                  <td>{contrato.plantilla_nombre}</td>
                  <td>{contrato.proyecto_nombre}</td>
                  <td>{contrato.proveedor_nombre || "Sin proveedor"}</td>
                  <td>
                    {contrato.documento ? (
                      <a
                        href={`${STORAGE_URL}contratos_documentos/${contrato.documento}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Ver documento
                      </a>
                    ) : (
                      "Sin documento"
                    )}
                  </td>
                  <td>{contrato.plantilla_estado}</td>
                  {/*<td>
                    {contrato.estatus === "Cancelado" && (
                      <span className="badge bg-danger">
                        {contrato.estatus}
                      </span>
                    )}
                    {contrato.estatus === "En proceso" && (
                      <span className="badge bg-warning">
                        {contrato.estatus}
                      </span>
                    )}
                    {contrato.estatus === "Validado" && (
                      <span className="badge bg-success">
                        {contrato.estatus}
                      </span>
                    )}
                  </td>*/}
                  <td className="d-flex gap-3">
                    <button
                      className="btn btn-dark btn-sm"
                      onClick={() => {
                        window.open(
                          `${API_URL}generar-contrato/${contrato.id}`,
                          "_blank",
                          "toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,modal=yes,top=100,left=250,width=1200,height=800"
                        );
                      }}
                    >
                      Ver
                    </button>
                    {canManage && (
                      <>
                        <button
                          className="btn btn-dark btn-sm"
                          onClick={() => {
                            setform(contrato);
                            toggleActualizar();
                          }}
                        >
                          Editar
                        </button>
                        <button
                          className="btn btn-dark btn-sm"
                          onClick={() => {
                            Swal.fire({
                              title: "¿Eliminar contrato?",
                              text: "Esta acción no se puede deshacer.",
                              icon: "warning",
                              showCancelButton: true,
                              confirmButtonColor: "#dc2626",
                              cancelButtonColor: "#3b82f6",
                              confirmButtonText: "Sí, eliminar",
                              cancelButtonText: "Cancelar",
                            }).then((resultado) => {
                              if (!resultado.isConfirmed) return;

                              ContratosDelete(
                                {
                                  id: contrato.id,
                                },
                                token
                              ).then((res) => {
                                if (res.success) {
                                  ContratosGet(token).then((res) => {
                                    setarrayContratosProd(res?.data ?? []);
                                  });
                                } else {
                                  Swal.fire({
                                    icon: "error",
                                    title: "No se pudo eliminar",
                                    text: "Intenta de nuevo.",
                                  });
                                }
                              });
                            });
                          }}
                        >
                          Eliminar
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Modal
        size="xl"
        isOpen={openAgregar}
        toggle={() => {
          setform({
            plantilla_numero: "",
            plantilla_nombre: "",
            plantilla_descripcion: "",
            plantilla_estado: "",
            proyecto_id: "",
            proveedor_id: "",
            plantilla_value: "",
            documento: "",
            estatus: "En proceso",
          });
          toggleAgregar();
        }}
      >
        <ModalHeader
          className="backend_titulo"
          toggle={() => {
            setform({
              plantilla_numero: "",
              plantilla_nombre: "",
              plantilla_descripcion: "",
              plantilla_estado: "",
              proyecto_id: "",
              proveedor_id: "",
              plantilla_value: "",
              documento: "",
              estatus: "En proceso",
            });
            toggleAgregar();
          }}
        >
          Agregar contrato
        </ModalHeader>
        <ModalBody>
          <Add
            form={form}
            setform={setform}
            arrayProyectos={proyectosDelProveedor}
            editorRef={editorRef}
            proveedores={proveedores}
            proveedoresReales={proveedoresReales}
          />
          <Editor
            apiKey={TINYMCE_API_KEY}
            onInit={(evt, editor) => (editorRef.current = editor)}
            initialValue="<p></p>"
            init={{
              height: 300,
              menubar: false,
              plugins: [
                "advlist autolink lists link image charmap print preview anchor",
                "searchreplace visualblocks code fullscreen",
                "insertdatetime media table paste code help wordcount",
              ],
              toolbar:
                "undo redo | formatselect | " +
                "bold italic backcolor | alignleft aligncenter " +
                "alignright alignjustify | bullist numlist outdent indent | " +
                "removeformat | help",
              content_style:
                "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            className="backend_boton"
            onClick={() => {
              form.plantilla_value = editorRef.current.getContent();
              ContratosAdd(form, token).then((res) => {
                if (res.success) {
                  ContratosGet(token).then((res) => {
                    setarrayContratosProd(res?.data ?? []);
                  });
                }
              });
              setform({
                plantilla_nombre: "",
                plantilla_descripcion: "",
                plantilla_estado: "",
                proyecto_id: "",
                proveedor_id: "",
                plantilla_value: "",
                documento: "",
                estatus: "En proceso",
              });
              setopenAgregar(false);
            }}
          >
            Agregar
          </Button>{" "}
        </ModalFooter>
      </Modal>

      <Modal
        size="xl"
        isOpen={openActualizar}
        toggle={() => {
          setform({
            plantilla_nombre: "",
            plantilla_descripcion: "",
            plantilla_estado: "",
            proyecto_id: "",
            proveedor_id: "",
            plantilla_value: "",
            documento: "",
            estatus: "En proceso",
          });
          toggleActualizar();
        }}
      >
        <ModalHeader
          className="backend_titulo"
          toggle={() => {
            setform({
              plantilla_nombre: "",
              plantilla_descripcion: "",
              plantilla_estado: "",
              proyecto_id: "",
              proveedor_id: "",
              plantilla_value: "",
              documento: "",
              estatus: "En proceso",
            });
            toggleActualizar();
          }}
        >
          Actualizar contrato
        </ModalHeader>
        <ModalBody>
          <Update
            form={form}
            setform={setform}
            arrayProyectos={proyectosDelProveedor}
            editorActualizarRef={editorActualizarRef}
            user_rol={user_rol}
            proveedores={proveedores}
            proveedoresReales={proveedoresReales}
          />
          <Editor
            apiKey={TINYMCE_API_KEY}
            onInit={(evt, editor) => (editorActualizarRef.current = editor)}
            initialValue="<p></p>"
            init={{
              height: 300,
              menubar: false,
              plugins: [
                "advlist autolink lists link image charmap print preview anchor",
                "searchreplace visualblocks code fullscreen",
                "insertdatetime media table paste code help wordcount",
              ],
              toolbar:
                "undo redo | formatselect | " +
                "bold italic backcolor | alignleft aligncenter " +
                "alignright alignjustify | bullist numlist outdent indent | " +
                "removeformat | help",
              content_style:
                "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            className="backend_boton"
            onClick={() => {
              form.plantilla_value = editorActualizarRef.current.getContent();
              ContratosUpdate(form, token).then((res) => {
                if (res.success) {
                  ContratosGet(token).then((res) => {
                    setarrayContratosProd(res?.data ?? []);
                  });
                  toggleActualizar();
                } else {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Algo salio mal!",
                  });
                }
              });
            }}
          >
            Actualizar
          </Button>{" "}
        </ModalFooter>
      </Modal>
    </div>
  );
}
